export default __webpack_public_path__ + "static/media/134.29a11647.jpg";